import React, { useContext } from "react";
import FilterBox from "../../../Utils/FilterBox/FilterBox"
import CompaniesContext from "../../../../context/companies-context"

function Filter(props) {
	
    const { setPageParams} = props

    let companies = useContext(CompaniesContext).onboarding_list

    let filterTypes = {
        event_date: {
            type: "date",
            disabled: false,
            validation:false,
            description: "Data"
        },
        external_id: {
            type: "string",
            disabled: false,
            validation:false,
            description: "ID"
        },
        document_number: {
            type: "brazilian_document_numbers",
            disabled: false,
            validation:true,
            validation_rule: {type: "multiple_equal", values:[14,18]},
            description: "CPF"
        },
        analysis_status: {
            type: "enum",
            enumList: [
                ["Em Processamento", "pending"],
                ["Em Análise Manual", "in_manual_analysis"],
                ["Aprovado Manualmente", "manually_approved"],
                ["Reprovado Manualmente", "manually_reproved"],
                ["Aprovado Automaticamente", "automatically_approved"],
                ["Reprovado Automaticamente", "automatically_reproved"],
                ["Contestado Manualmente", "manually_challenged"],
                ["Contestado Automaticamente", "automatically_challenged"],
                ["Em Espera", "on_hold"]
            ],
            disabled: false,
            validation:false,
            description: "Status"
        }
    }

    if (companies){
        let enumList = companies.companies.sort((a, b) => a.name === b.name ? 0 : a.name > b.name ? 1 : -1).map(company =>{
            return [company.name, company.company_key]
        })
        filterTypes['company_key'] = {
            type: "enum",
            enumList: [
                ["Nenhum", ""],
                ...enumList
            ],  
            disabled: false,
            validation:false,
            description: "Cliente"
        }
    }

    return (
        <FilterBox 
                setPageParams={setPageParams}
                filterTypes={filterTypes}
                local_storage_object_preffix={props.local_storage_object_preffix}
            />
    )

}

export default Filter
